import React, { Fragment, useState, useEffect, useRef } from 'react';
import './relatedContents.scss';
import axios from 'axios';
import logo from '../../assets/logo.png';

function RelatedContents() {
  const [currentUrl, setCurrentUrl] = useState();
  const [alignLeft, setAlignLeft] = useState(false);
  const [currentWidth, setCurrentWidth] = useState(window.innerWidth);
  const [tiles, setTiles] = useState();
  const [relatedContentsData, setRelatedContentsData] = useState();

  const tileRef = useRef();

  useEffect(() => {
    const path = window.location.pathname;
    const array = path.split('/');
    setCurrentUrl(array[3]);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await axios(
          'https://courageous-sponsorcontent-cdn.s3.amazonaws.com/intel/intel2023RelatedContents.json'
        );
        const jsonData = JSON.parse(JSON.stringify(result.data));
        const data = jsonData.articles;
        setRelatedContentsData(data);
        setTiles(data.length - 1);
      } catch (error) {
        console.log('theres an error', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setCurrentWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize, { passive: true });
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (tileRef.current) {
      const tileWidth = tileRef.current.getBoundingClientRect().width;
      const tilesWidth = tiles * (tileWidth + 20);
      if (currentWidth < tilesWidth) {
        setAlignLeft(true);
      } else {
        setAlignLeft(false);
      }
    }
  }, [tiles, currentWidth]);

  return (
    <section className="relatedContents">
      <div
        className="relatedContents-wrapper"
        style={
          alignLeft
            ? { justifyContent: 'flex-start', padding: '0 30px' }
            : { justifyContent: 'center', padding: '0' }
        }
      >
        <div
          className="relatedContents__tiles"
          style={alignLeft ? { justifyContent: 'flex-start' } : { justifyContent: 'center' }}
        >
          {relatedContentsData &&
            relatedContentsData.map((data, i) => {
              return (
                <Fragment key={data.content}>
                  {currentUrl !== data.content ? (
                    <div
                      className={`relatedContents__tile relatedContents__tile-${data.content}`}
                      key={i}
                      style={{ backgroundImage: `url(${data.background})` }}
                      ref={tileRef}
                    >
                      <div className="relatedContents__tile--contents relatedContents__tile__content">
                        <h4>{data.title}</h4>
                        <a href={data.url} target="_blank" rel="noreferrer">
                          {data.button}
                        </a>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </Fragment>
              );
            })}
        </div>
      </div>
      <img src={logo} className="relatedContents__logo" alt="It Starts With Intel Logo" />
    </section>
  );
}

export default RelatedContents;
